export const WEAPONS = [
    { name: 'Club', type: 'Simple', damage: '1d4', damageType: 'Bludgeoning', properties: ['Light'] },
    { name: 'Dagger', type: 'Simple', damage: '1d4', damageType: 'Piercing', properties: ['Finesse', 'Light', 'Thrown (20/60)'] },
    { name: 'Greatclub', type: 'Simple', damage: '1d8', damageType: 'Bludgeoning', properties: ['Two-Handed'] },
    { name: 'Handaxe', type: 'Simple', damage: '1d6', damageType: 'Slashing', properties: ['Light', 'Thrown (20/60)'] },
    { name: 'Javelin', type: 'Simple', damage: '1d6', damageType: 'Piercing', properties: ['Thrown (30/120)'] },
    { name: 'Light Hammer', type: 'Simple', damage: '1d4', damageType: 'Bludgeoning', properties: ['Light', 'Thrown (20/60)'] },
    { name: 'Mace', type: 'Simple', damage: '1d6', damageType: 'Bludgeoning', properties: [] },
    { name: 'Quarterstaff', type: 'Simple', damage: '1d6', damageType: 'Bludgeoning', properties: ['Versatile (1d8)'] },
    { name: 'Sickle', type: 'Simple', damage: '1d4', damageType: 'Slashing', properties: ['Light'] },
    { name: 'Spear', type: 'Simple', damage: '1d6', damageType: 'Piercing', properties: ['Thrown (20/60)', 'Versatile (1d8)'] },
    { name: 'Light Crossbow', type: 'Simple', damage: '1d8', damageType: 'Piercing', properties: ['Ammunition', 'Range (80/320)', 'Loading', 'Two-Handed'] },
    { name: 'Dart', type: 'Simple', damage: '1d4', damageType: 'Piercing', properties: ['Finesse', 'Thrown (20/60)'] },
    { name: 'Shortbow', type: 'Simple', damage: '1d6', damageType: 'Piercing', properties: ['Ammunition', 'Two-Handed', 'Range (80/320)'] },
    { name: 'Sling', type: 'Simple', damage: '1d4', damageType: 'Bludgeoning', properties: ['Ammunition', 'Range (30/120)'] },

    // Martial Melee
    { name: 'Battleaxe', type: 'Martial', damage: '1d8', damageType: 'Slashing', properties: ['Versatile (1d10)'] },
    { name: 'Flail', type: 'Martial', damage: '1d8', damageType: 'Bludgeoning', properties: [] },
    { name: 'Glaive', type: 'Martial', damage: '1d10', damageType: 'Slashing', properties: ['Heavy', 'Reach', 'Two-Handed'] },
    { name: 'Greataxe', type: 'Martial', damage: '1d12', damageType: 'Slashing', properties: ['Heavy', 'Two-Handed'] },
    { name: 'Greatsword', type: 'Martial', damage: '2d6', damageType: 'Slashing', properties: ['Heavy', 'Two-Handed'] },
    { name: 'Halberd', type: 'Martial', damage: '1d10', damageType: 'Slashing', properties: ['Heavy', 'Reach', 'Two-Handed'] },
    { name: 'Lance', type: 'Martial', damage: '1d12', damageType: 'Piercing', properties: ['Reach', 'Special'] },
    { name: 'Longsword', type: 'Martial', damage: '1d8', damageType: 'Slashing', properties: ['Versatile (1d10)'] },
    { name: 'Maul', type: 'Martial', damage: '2d6', damageType: 'Bludgeoning', properties: ['Heavy', 'Two-Handed'] },
    { name: 'Morningstar', type: 'Martial', damage: '1d8', damageType: 'Piercing', properties: [] },
    { name: 'Pike', type: 'Martial', damage: '1d10', damageType: 'Piercing', properties: ['Heavy', 'Reach', 'Two-Handed'] },
    { name: 'Rapier', type: 'Martial', damage: '1d8', damageType: 'Piercing', properties: ['Finesse'] },
    { name: 'Scimitar', type: 'Martial', damage: '1d6', damageType: 'Slashing', properties: ['Finesse', 'Light'] },
    { name: 'Shortsword', type: 'Martial', damage: '1d6', damageType: 'Piercing', properties: ['Finesse', 'Light'] },
    { name: 'Trident', type: 'Martial', damage: '1d6', damageType: 'Piercing', properties: ['Thrown (20/60)', 'Versatile (1d8)'] },
    { name: 'War Pick', type: 'Martial', damage: '1d8', damageType: 'Piercing', properties: [] },
    { name: 'Warhammer', type: 'Martial', damage: '1d8', damageType: 'Bludgeoning', properties: ['Versatile (1d10)'] },
    { name: 'Whip', type: 'Martial', damage: '1d4', damageType: 'Slashing', properties: ['Finesse', 'Reach'] },

    // Martial Ranged
    { name: 'Blowgun', type: 'Martial', damage: '1', damageType: 'Piercing', properties: ['Ammunition', 'Range (25/100)', 'Loading'] },
    { name: 'Hand Crossbow', type: 'Martial', damage: '1d6', damageType: 'Piercing', properties: ['Ammunition', 'Range (30/120)', 'Light', 'Loading'] },
    { name: 'Heavy Crossbow', type: 'Martial', damage: '1d10', damageType: 'Piercing', properties: ['Ammunition', 'Range (100/400)', 'Heavy', 'Loading', 'Two-Handed'] },
    { name: 'Longbow', type: 'Martial', damage: '1d8', damageType: 'Piercing', properties: ['Ammunition', 'Range (150/600)', 'Heavy', 'Two-Handed'] },
    { name: 'Net', type: 'Martial', damage: '-', damageType: '-', properties: ['Special', 'Thrown (5/15)'] },
];

export const ARMOR = [
    // Light
    { name: 'Padded', type: 'Light', ac: 11, stealthDisadvantage: true },
    { name: 'Leather', type: 'Light', ac: 11, stealthDisadvantage: false },
    { name: 'Studded Leather', type: 'Light', ac: 12, stealthDisadvantage: false },
    // Medium
    { name: 'Hide', type: 'Medium', ac: 12, stealthDisadvantage: false },
    { name: 'Chain Shirt', type: 'Medium', ac: 13, stealthDisadvantage: false },
    { name: 'Scale Mail', type: 'Medium', ac: 14, stealthDisadvantage: true },
    { name: 'Breastplate', type: 'Medium', ac: 14, stealthDisadvantage: false },
    { name: 'Half Plate', type: 'Medium', ac: 15, stealthDisadvantage: true },
    // Heavy
    { name: 'Ring Mail', type: 'Heavy', ac: 14, stealthDisadvantage: true },
    { name: 'Chain Mail', type: 'Heavy', ac: 16, stealthDisadvantage: true },
    { name: 'Splint', type: 'Heavy', ac: 17, stealthDisadvantage: true },
    { name: 'Plate', type: 'Heavy', ac: 18, stealthDisadvantage: true },
    // Shield
    { name: 'Shield', type: 'Shield', ac: 2, stealthDisadvantage: false },
];

export const ITEMS = [
    { name: 'Backpack', notes: 'Capacity: 30 lb' },
    { name: 'Bedroll', notes: '' },
    { name: 'Candle', notes: '1 hour light' },
    { name: 'Crowbar', notes: 'Advantage on leverage' },
    { name: 'Hammer', notes: '' },
    { name: 'Piton', notes: '' },
    { name: 'Torch', notes: '1 hour bright light' },
    { name: 'Rations (1 day)', notes: '' },
    { name: 'Waterskin', notes: '4 pints' },
    { name: 'Rope, Hempen (50 ft)', notes: '' },
    { name: 'Spellbook', notes: '' },
    { name: 'Tinderbox', notes: 'Light fires' },
    { name: 'Healer\'s Kit', notes: 'Stabilize 0 HP' },
    { name: 'Potion of Healing', notes: '2d4 + 2 HP' },
];
